<template>
  <div>
    <van-popup
      v-model="visible"
      :closeable="false"
      :close-icon="closeIcon"
      @click-overlay="handleClickOverlay"
      @close="handleClose"
      class="login-popup"
    >
      <!-- Close Button -->
      <button class="login-popup__close" @click="logClose">
        <van-icon name="cross" size="18" color="rgba(255,255,255,0.5)" />
      </button>

      <!-- Header Image -->
      <div class="login-popup__banner">
        <img src="../assets/img/sign_in/header.jpg" class="login-popup__banner-img" />
      </div>

      <!-- Tab Switcher -->
      <div class="login-popup__tabs">
        <div
          class="login-popup__tab"
          :class="{ 'login-popup__tab--active': selectIndex === 0 }"
          @click="selectTab(0)"
        >
          {{ $lang.Entrar || 'Sign In' }}
        </div>
        <div
          class="login-popup__tab"
          :class="{ 'login-popup__tab--active': selectIndex === 1 }"
          @click="selectTab(1)"
        >
          {{ $lang.Registro || 'Register' }}
        </div>
      </div>

      <!-- Form -->
      <div class="login-popup__form">
        <!-- Phone Input -->
        <div class="login-popup__field-row" style="position: relative;">
          <div class="login-popup__area-code" @click="getLangT">
            <img :src="selectedIcon || GET_ICONURL" width="22" />
            <span class="login-popup__area-code-text">{{ selectedAreaCode || GET_AREACODE }}</span>
            <van-icon :name="showCountryDrop ? 'arrow-up' : 'arrow-down'" size="10" color="#94a3b8" />
          </div>
          <!-- Country Dropdown -->
          <div v-if="showCountryDrop" class="login-popup__dropdown">
            <div
              v-for="(item, idx) in countryList"
              :key="idx"
              class="login-popup__dropdown-item"
              @click="selectCountry(item)"
            >
              <img :src="item.iconUrl" width="24" />
              <span>{{ item.countryName }}</span>
              <span class="login-popup__dropdown-code">{{ item.areaCode }}</span>
            </div>
            <div v-if="countryList.length === 0" class="login-popup__dropdown-item" style="justify-content: center; color: #6b7280;">
              {{ $lang.common_loading || 'Loading...' }}
            </div>
          </div>
          <van-field
            v-model="account"
            :placeholder="$lang.login_txt || 'Enter mobile number'"
            class="login-popup__input"
            :class="{ 'login-popup__input--focus': isFocused, 'login-popup__input--error': vError1 }"
            @focus="isFocused = true"
            @blur="isFocused = false"
            :update:model-value="(account = account.replace(/\D/g, '').slice(0, 13))"
            @input="getError3"
            type="number"
          />
        </div>
        <p v-if="vError1" class="login-popup__error">
          <van-icon name="warning" color="#ef4444" size="12" /> {{ vError1 }}
        </p>

        <!-- Captcha (Register + GHS only) -->
        <div v-if="selectIndex === 1 && isGhsCurrency" class="login-popup__field">
          <van-field
            v-model="captcha"
            :placeholder="$lang.login_captcha_placeholder || 'Enter verification code'"
            class="login-popup__input login-popup__input--captcha"
            :class="{ 'login-popup__input--focus': isFocusedCaptcha, 'login-popup__input--error': vErrorCaptcha }"
            @focus="isFocusedCaptcha = true"
            @blur="isFocusedCaptcha = false"
            :update:model-value="(captcha = captcha.replace(/\\s+/g, ''))"
            @input="getCaptchaError"
          >
            <template #button>
              <span
                class="login-popup__captcha-send"
                :class="{ 'login-popup__captcha-send--disabled': !canSendCaptcha }"
                @click="sendCaptcha"
              >
                {{ captchaCountdown > 0 ? `${captchaCountdown}s` : ($lang.login_captcha_send || 'Send') }}
              </span>
            </template>
          </van-field>
        </div>
        <p v-if="selectIndex === 1 && isGhsCurrency && vErrorCaptcha" class="login-popup__error">
          <van-icon name="warning" color="#ef4444" size="12" /> {{ vErrorCaptcha }}
        </p>

        <!-- Password -->
        <div class="login-popup__field">
          <van-field
            v-model="passwd"
            :placeholder="$lang.login_txt4 || 'Password'"
            class="login-popup__input login-popup__input--icon"
            :class="{ 'login-popup__input--focus': isFocused2, 'login-popup__input--error': vError2 }"
            @focus="isFocused2 = true"
            @blur="isFocused2 = false"
            :type="!isShowMm ? 'password' : ''"
            :update:model-value="(passwd = passwd.replace(/\\s+/g, ''))"
            @input="getError"
          >
            <template #left-icon>
              <van-icon name="lock" size="18" color="#94a3b8" />
            </template>
            <template #right-icon>
              <van-icon
                :name="isShowMm ? 'eye-o' : 'closed-eye'"
                size="18"
                color="#94a3b8"
                @click="isShowMm = !isShowMm"
              />
            </template>
          </van-field>
        </div>
        <p v-if="vError2" class="login-popup__error">
          <van-icon name="warning" color="#ef4444" size="12" /> {{ vError2 }}
        </p>

        <!-- Confirm Password (Register only) -->
        <div v-if="selectIndex === 1" class="login-popup__field">
          <van-field
            v-model="conPasswd"
            :placeholder="$lang.login_txt6 || 'Confirm your password'"
            class="login-popup__input login-popup__input--icon"
            :class="{ 'login-popup__input--focus': isFocused3, 'login-popup__input--error': vError3 }"
            @focus="isFocused3 = true"
            @blur="isFocused3 = false"
            :type="!isShowMm2 ? 'password' : ''"
            :update:model-value="(conPasswd = conPasswd.replace(/\\s+/g, ''))"
            @input="getError2"
          >
            <template #left-icon>
              <van-icon name="lock" size="18" color="#94a3b8" />
            </template>
            <template #right-icon>
              <van-icon
                :name="isShowMm2 ? 'eye-o' : 'closed-eye'"
                size="18"
                color="#94a3b8"
                @click="isShowMm2 = !isShowMm2"
              />
            </template>
          </van-field>
        </div>
        <p v-if="selectIndex === 1 && vError3" class="login-popup__error">
          <van-icon name="warning" color="#ef4444" size="12" /> {{ vError3 }}
        </p>

        <!-- Submit Button -->
        <button
          class="login-popup__submit"
          :class="{ 'login-popup__submit--disabled': !isBtnEnable }"
          :disabled="!isBtnEnable"
          @click="LoginBtn"
        >
          {{ selectIndex === 0 ? ($lang.Entrar || 'Sign In') : ($lang.Registro || 'Register') }}
        </button>

        <!-- Agreement Checkbox -->
        <div class="login-popup__agree">
          <van-checkbox
            v-model="agree"
            shape="square"
            checked-color="#24ee89"
            icon-size="14px"
          >
            <span class="login-popup__agree-text">{{ $lang.common_txt271 || 'Agree or disagree with the Service Policy and Privacy Policy' }}</span>
          </van-checkbox>
        </div>

        <!-- Google Divider -->
        <div class="login-popup__divider">
          <span class="login-popup__divider-line"></span>
          <span class="login-popup__divider-text">{{ $lang.login_txt12 || 'OR' }}</span>
          <span class="login-popup__divider-line"></span>
        </div>

        <!-- Google Login -->
        <button class="login-popup__google" @click="handleGoogleLogin" :disabled="googleLoading">
          <svg viewBox="0 0 48 48" width="18" height="18">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59A14.5 14.5 0 0 1 9.5 24c0-1.59.28-3.14.76-4.59l-7.98-6.19A23.99 23.99 0 0 0 0 24c0 3.77.9 7.35 2.56 10.52l7.97-5.93z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 5.93C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          <span>{{ $lang.google_login || 'Sign in with Google' }}</span>
        </button>
      </div>
    </van-popup>

    <!-- Google Registration Popup -->
    <van-popup
      v-model="showGoogleRegister"
      :closeable="true"
      close-icon="cross"
      round
      class="google-reg-popup"
    >
      <div class="google-reg">
        <h3 class="google-reg__title">{{ $lang.google_register_title || 'Complete Registration' }}</h3>
        <div class="login-popup__field-row">
          <div class="login-popup__area-code" @click="showGoogleRegisterLang">
            <img :src="selectedIcon || GET_ICONURL" width="22" />
            <span class="login-popup__area-code-text">{{ selectedAreaCode || GET_AREACODE }}</span>
            <van-icon name="arrow-down" size="10" color="#94a3b8" />
          </div>
          <van-field
            v-model="googlePhoneNo"
            :placeholder="$lang.google_register_phone || 'Enter phone number'"
            class="login-popup__input"
            :update:model-value="(googlePhoneNo = googlePhoneNo.replace(/\D/g, '').slice(0, 13))"
            type="number"
          />
        </div>
        <p v-if="googleRegError" class="login-popup__error">
          <van-icon name="warning" color="#ef4444" size="12" /> {{ googleRegError }}
        </p>
        <button
          class="login-popup__submit"
          :disabled="!googlePhoneNo || googleRegLoading"
          :class="{ 'login-popup__submit--disabled': !googlePhoneNo }"
          @click="handleGoogleRegister"
        >
          {{ $lang.Registro || 'Register' }}
        </button>
      </div>
    </van-popup>

    <Vcode
      :show="isShow"
      @success="success"
      @close="close2"
      :successText="$lang.login_txt13"
      :failText="$lang.login_txt14"
      :sliderText="$lang.login_txt15"
      style="z-index: 9999999"
    />
  </div>
</template>

<script>
import Vcode from 'vue-puzzle-vcode'

import { Login, Register, GetIsFbReport, GetInvitationID, GetPlatformList, GetGoogleAuthorizingUrl, GoogleRegister, GetCaptcha } from '@/api/common'
import { logoutIfReloginRequiredWithToken } from '@/utils/platformAuth'
import md5 from 'md5'
export default {
  components: { Vcode },
  name: 'Login',
  props: {
    // 控制弹窗显示的布尔值
    value: {
      type: Boolean,
      default: false
    },
    // 是否显示关闭按钮
    closeable: {
      type: Boolean,
      default: false
    },
    // 关闭按钮的图标
    closeIcon: {
      type: String,
      default: 'cross'
    },
    // 是否显示遮罩层
    overlay: {
      type: Boolean,
      default: true
    },
    loginType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showLang: false,
      showCountryDrop: false,
      countryList: [],
      selectedIcon: localStorage.getItem('iconUrl'),
      selectedAreaCode: localStorage.getItem('areaCode'),
      isShow: false,
      isShowMm: false,
      isShowMm2: false,
      agree: true,
      agree2: true,
      vError1: '',
      vError2: '',
      vError3: '',
      vErrorCaptcha: '',
      isFocused: false, // 用于标记是否聚焦
      isFocused2: false, // 用于标记是否聚焦
      isFocused3: false,
      isFocusedCaptcha: false,
      account: '',
      passwd: '',
      conPasswd: '',
      captcha: '',
      captchaCountdown: 0,
      captchaTimer: null,
      isCaptchaSending: false,
      isLogin: true,
      visible: this.value, // 内部状态
      registerParames: {},
      selectIndex: 0,
      // Google login
      googleLoading: false,
      showGoogleRegister: false,
      googlePhoneNo: '',
      googleThirdUuid: '',
      googleRegError: '',
      googleRegLoading: false
    }
  },
  // 新增：计算按钮是否可点击
  computed: {
    isGhsCurrency() {
      return localStorage.getItem('currency') === 'GHS'
    },
    canSendCaptcha() {
      return !this.isCaptchaSending && this.captchaCountdown === 0
    },
    isBtnEnable() {
      if (this.selectIndex === 0) {
        // 登录标签页：账号(8-13位数字)/密码非空 + 无错误提示
        return (
          /^\d{8,13}$/.test(this.account) &&
          this.passwd &&
          !this.vError1 &&
          !this.vError2
        )
      } else {
        // 注册标签页：账号(8-13位数字)/密码/确认密码非空 + 无错误提示 + 同意协议
        const baseEnable = (
          /^\d{8,13}$/.test(this.account) &&
          this.passwd &&
          this.conPasswd &&
          !this.vError1 &&
          !this.vError2 &&
          !this.vError3 &&
          this.agree
        )

        if (this.isGhsCurrency) {
          return baseEnable && this.captcha && !this.vErrorCaptcha
        }

        return baseEnable
      }
    }
  },
  watch: {
    // 监听外部传入的 value 值变化
    value(newVal) {
      this.visible = newVal
    },
    // 监听内部 visible 值变化，同步到外部
    visible(newVal) {
      this.$emit('input', newVal)
      this.selectTab(this.loginType)
      if (newVal) {
        this.GetInvitationID()
      }
    }
  },
  mounted() {
    // Google callback is handled by App.vue (checkGoogleCallback)
  },
  methods: {
    async GetInvitationID() {
      const data = await GetInvitationID({
        inviteCode: localStorage.getItem('id')
      })
      if (data.status === 'ok') {
        if (data.content.invitCode) {
          localStorage.setItem('id', data.content.invitCode)
        }
      }
    },
    getLangT() {
      this.showCountryDrop = !this.showCountryDrop
      if (this.showCountryDrop && this.countryList.length === 0) {
        this.fetchCountryList()
      }
    },
    async fetchCountryList() {
      try {
        const data = await GetPlatformList()
        if (data.status === 'ok') {
          this.countryList = data.content.list
        }
      } catch (e) {
        console.error('fetchCountryList error', e)
      }
    },
    selectCountry(item) {
      const prevPlatform = localStorage.getItem('platform')
      logoutIfReloginRequiredWithToken(prevPlatform, item.platform)
      this.selectedIcon = item.iconUrl
      this.selectedAreaCode = item.areaCode
      localStorage.setItem('areaCode', item.areaCode)
      localStorage.setItem('iconUrl', item.iconUrl)
      localStorage.setItem('currency', item.currency)
      localStorage.setItem('currencyUnit', item.currencyUnit)
      localStorage.setItem('platform', item.platform)
      localStorage.setItem('defaultLanguage', item.defaultLanguage)
      localStorage.setItem('countryName', item.countryName)
      localStorage.setItem('country', item.country)
      this.showCountryDrop = false
      // Reload to apply the new language
      setTimeout(() => {
        window.location.reload()
      }, 200)
    },
    goToActive() {
      this.$jumpTo('/activityCooperate')
    },
    getError3(v) {
      // 修改2：只保留数字，限制最大长度13位
      this.account = v.replace(/\D/g, '').slice(0, 13)

      // 修改3：注册页验证账号长度
      if (this.selectIndex === 1) {
        if (this.account.length === 0) {
          this.vError1 = ''
        } else if (this.account.length < 8 || this.account.length > 13) {
          this.vError1 = this.$lang.common_txt369 // 可替换为对应的$lang变量
        } else {
          this.vError1 = ''
        }
      }
    },
    getError(v) {
      if (this.selectIndex === 1) {
        if (v.length === 0) {
          this.vError2 = ''
        } else if (v.length > 16 || v.length < 6) {
          this.vError2 = this.$lang.login_txt17
        } else {
          this.vError2 = ''
        }
      }
    },
    getError2(v) {
      if (this.selectIndex === 1) {
        if (v.length === 0) {
          this.vError3 = ''
        } else if (v !== this.passwd) {
          this.vError3 = this.$lang.login_txt18
        } else {
          this.vError3 = ''
        }
      }
    },
    getCaptchaError(v) {
      if (this.selectIndex === 1 && this.isGhsCurrency) {
        if (!v) {
          this.vErrorCaptcha = ''
        } else {
          this.vErrorCaptcha = ''
        }
      }
    },
    startCaptchaCountdown() {
      this.captchaCountdown = 60
      if (this.captchaTimer) {
        clearInterval(this.captchaTimer)
      }
      this.captchaTimer = setInterval(() => {
        if (this.captchaCountdown > 0) {
          this.captchaCountdown -= 1
        } else {
          clearInterval(this.captchaTimer)
          this.captchaTimer = null
        }
      }, 1000)
    },
    clearCaptchaState() {
      this.captcha = ''
      this.vErrorCaptcha = ''
      this.captchaCountdown = 0
      this.isCaptchaSending = false
      if (this.captchaTimer) {
        clearInterval(this.captchaTimer)
        this.captchaTimer = null
      }
    },
    async sendCaptcha() {
      if (this.selectIndex !== 1 || !this.isGhsCurrency || !this.canSendCaptcha) {
        return
      }
      if (!this.account) {
        this.vError1 = this.$lang.login_txt19
        return
      }
      if (!/^\d{8,13}$/.test(this.account)) {
        this.vError1 = this.$lang.common_txt369
        return
      }
      this.vError1 = ''
      this.isCaptchaSending = true
      try {
        const data = await GetCaptcha({
          areaCode: this.GET_AREACODE,
          phoneNo: this.account,
            captchaType: "register"
        })
        if (data.status === 'ok') {
          this.startCaptchaCountdown()
        } else {
          this.$toast({
            message: data.msg,
            icon: 'cross'
          })
        }
      } catch (e) {
        this.$toast({
          message: this.$lang.network_error || 'Network error',
          icon: 'cross'
        })
      } finally {
        this.isCaptchaSending = false
      }
    },
    // 用户通过了验证
    success() {
      this.isShow = false // 通过验证后，需要手动隐藏模态框
      this.Register()
    },
    // 用户点击遮罩层，应该关闭模态框
    close2() {
      this.isShow = false
    },
    logClose() {
      this.visible = false
      this.account = ''
      this.passwd = ''
      this.conPasswd = ''
      this.vError1 = ''
      this.vError2 = ''
      this.vError3 = ''
      this.clearCaptchaState()
      this.isShowMm = false
      this.isShowMm2 = false
    },
    selectTab(i) {
      this.selectIndex = i
      this.vError1 = ''
      this.vError2 = ''
      this.vError3 = ''
      this.account = ''
      this.passwd = ''
      this.conPasswd = ''
      this.clearCaptchaState()
    },
    gotoPrivacy() {
      this.$jumpTo('/privacy')
    },
    isLoginRegister() {
      this.isLogin = !this.isLogin
    },
    // 点击遮罩层时触发
    handleClickOverlay() {
      this.$emit('click-overlay')
    },
    // 弹窗关闭时触发
    handleClose() {
      this.$emit('close')
    },
    async GetIsFbReport() {
      const data = await GetIsFbReport({
        inviteCode: localStorage.getItem('id')
      })
      if (data.status === 'ok') {
        if (data.content.isReport) {
          if (data.content.target === 'ks') {
            window.kwaiq.load(data.content.fbPixId)
            window.kwaiq
              .instance(data.content.fbPixId)
              .track('completeRegistration')
            console.log('completeRegistration')
          } else {
            this.$pixel.setFbId(data.content.fbPixId)
            this.$pixel.callTrack('track', 'CompleteRegistration') // 上报
            const jsonData = ` ""{"data":[{"event_name": "CompleteRegistration","status": "success","value": 0.00,"currency": "NGN"}]}""`
            this.$pixel.sendEventToAndroid(jsonData)
          }
        }
      }
    },
    async Register() {
      // 修改4：注册时账号直接使用纯数字
      this.registerParames.areaCode = this.GET_AREACODE
      this.registerParames.phoneNo = this.account
      this.registerParames.email = ''
      if (this.isGhsCurrency) {
        this.registerParames.captcha = this.captcha
      } else {
        delete this.registerParames.captcha
      }

      if (localStorage.getItem('id')) {
        this.registerParames.account = this.account
        this.registerParames.passwd = md5(this.passwd)
        this.registerParames.loginType = 'account'
        this.registerParames.id = localStorage.getItem('id')
        this.registerParames.fbExpand = localStorage.getItem('fbExpand')
      } else {
        this.registerParames.account = this.account
        this.registerParames.passwd = md5(this.passwd)
        this.registerParames.loginType = 'account'
      }
      this.GetIsFbReport()
      const data = await Register(this.registerParames)
      if (data.status === 'ok') {
        this.visible = false
        localStorage.setItem('token', data.content.accessToken) // 将 Token 保存到 localStorage
        // localStorage.setItem('currency', data.content._currency) // 将 Token 保存到 localStorage
        setTimeout(() => {
          window.location.reload()
        }, 200)
        localStorage.setItem('isRegister', 'isRegister')
        this.$emit('close-key')
      } else {
        this.$toast({
          message: data.msg,
          icon: 'cross'
        })
      }
    },
    async Login() {
      const data = await Login({
        account: this.account,
        passwd: md5(this.passwd),
        loginType: 'account'
      })
      if (data.status === 'ok') {
        this.visible = false
        localStorage.setItem('token', data.content.accessToken) // 将 Token 保存到 localStorage
        // localStorage.setItem('currency', data.content._currency) // 将 Token 保存到 localStorage
        setTimeout(() => {
          window.location.reload()
        }, 200)
        this.$emit('close-key')
      } else {
        this.$toast({
          message: data.msg,
          icon: 'cross'
        })
      }
    },
    // 登录
    async LoginBtn() {
      // 修改5：更新账号验证规则
      if (!this.account) {
        this.vError1 = this.$lang.login_txt19
      } else if (!/^\d{8,13}$/.test(this.account)) {
        this.vError1 = this.$lang.common_txt369 // 可替换为对应的$lang变量
      } else {
        this.vError1 = ''
      }

      if (!this.passwd) {
        this.vError2 = this.$lang.login_txt19
      } else if (this.passwd.length > 16 || this.passwd.length < 6) {
        this.vError2 = this.$lang.login_txt21
      } else {
        this.vError2 = ''
      }

      if (this.selectIndex === 1) {
        if (!this.conPasswd) {
          this.vError3 = this.$lang.login_txt19
        } else if (this.conPasswd !== this.passwd) {
          this.vError3 = this.$lang.login_txt19
        } else {
          this.vError3 = ''
        }
      }

      if (this.selectIndex === 1 && this.isGhsCurrency) {
        if (!this.captcha) {
          this.vErrorCaptcha = this.$lang.login_txt19
        } else {
          this.vErrorCaptcha = ''
        }
      } else {
        this.vErrorCaptcha = ''
      }

      if (!this.agree && this.selectIndex === 1) {
        this.$toast({
          message: this.$lang.login_txt22,
          icon: 'info',
          className: 'toastIndex' // 给toast添加类名
        })
        return
      }

      // 修改6：更新提交条件
      if (
        this.selectIndex === 1 &&
        !this.vError1 &&
        !this.vError2 &&
        !this.vError3 &&
        (!this.isGhsCurrency || !this.vErrorCaptcha) &&
        this.agree
      ) {
        this.Register()
      } else if (this.selectIndex === 0 && !this.vError1 && !this.vError2) {
        this.Login()
      }
    },
    // Google Login: Step 1 - get auth URL and redirect
    async handleGoogleLogin() {
      console.log('[Google OAuth] handleGoogleLogin clicked')
      this.googleLoading = true
      try {
        const toUrl = window.location.origin
        console.log('[Google OAuth] Calling GetGoogleAuthorizingUrl with toUrl:', toUrl)
        const data = await GetGoogleAuthorizingUrl({
          toUrl: toUrl,
          isWap: true
        })
        console.log('[Google OAuth] GetGoogleAuthorizingUrl response:', JSON.stringify(data).substring(0, 500))
        if (data.status === 'ok' && data.content && data.content.redirectUri) {
          console.log('[Google OAuth] Redirecting to:', data.content.redirectUri)
          localStorage.setItem('googleToUrl', toUrl)
          window.location.href = data.content.redirectUri
        } else {
          this.$toast({
            message: data.msg || this.$lang.google_login_url_failed,
            icon: 'cross'
          })
        }
      } catch (e) {
        console.error('[Google OAuth] handleGoogleLogin error:', e)
        this.$toast({
          message: this.$lang.network_error,
          icon: 'cross'
        })
      } finally {
        this.googleLoading = false
      }
    },
    // Google Login: Step 3 - register with phone
    async handleGoogleRegister() {
      if (!this.googlePhoneNo) {
        this.googleRegError = this.$lang.login_txt19 || 'Please enter the content'
        return
      }
      if (!/^\d{8,13}$/.test(this.googlePhoneNo)) {
        this.googleRegError = this.$lang.common_txt369 || 'The account number must consist of 8 to 13 digits only.'
        return
      }
      this.googleRegError = ''
      this.googleRegLoading = true
      try {
        const params = {
          thirdUuid: this.googleThirdUuid,
          phoneNo: this.googlePhoneNo,
          areaCode: this.GET_AREACODE,
          isWap: true
        }
        if (localStorage.getItem('id')) {
          params.id = localStorage.getItem('id')
        }
        if (localStorage.getItem('fbExpand')) {
          params.fbExpand = localStorage.getItem('fbExpand')
        }
        const data = await GoogleRegister(params)
        if (data.status === 'ok' && data.content) {
          localStorage.setItem('token', data.content.accessToken)
          localStorage.removeItem('googleToUrl')
          this.showGoogleRegister = false
          localStorage.setItem('isRegister', 'isRegister')
          setTimeout(() => {
            window.location.reload()
          }, 200)
        } else {
          this.googleRegError = data.msg || this.$lang.google_register_failed
        }
      } catch (e) {
        this.googleRegError = this.$lang.network_error
      } finally {
        this.googleRegLoading = false
      }
    },
    showGoogleRegisterLang() {
      this.showGoogleRegister = false
      this.showLang = true
    }
  },
  beforeDestroy() {
    if (this.captchaTimer) {
      clearInterval(this.captchaTimer)
      this.captchaTimer = null
    }
  }
}
</script>

<style lang="less" scoped>
@bg: #1a1d29;
@card: #252936;
@input-bg: #2a2f3e;
@neon: #24ee89;
@border: rgba(255, 255, 255, 0.08);
@muted: #94a3b8;

// ====== POPUP ======
.login-popup {
  overflow: hidden;
  width: 93%;
  max-width: 420px;
  background: @bg !important;
  border-radius: 16px !important;
  padding-bottom: 24px;
}

.login-popup__close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  border: none;
  border-radius: 50%;
  cursor: pointer;
}

// ====== BANNER ======
.login-popup__banner {
  width: 100%;
  overflow: hidden;

  &-img {
    width: 100%;
    display: block;
    object-fit: cover;
  }
}

// ====== TABS ======
.login-popup__tabs {
  display: flex;
  margin: 0 20px;
  border-bottom: 1px solid @border;
}

.login-popup__tab {
  flex: 1;
  text-align: center;
  padding: 14px 0;
  font-size: 15px;
  font-weight: 600;
  color: @muted;
  cursor: pointer;
  position: relative;
  transition: color 0.2s;

  &--active {
    color: #ffffff;

    &::after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 20%;
      right: 20%;
      height: 3px;
      background: @neon;
      border-radius: 3px;
    }
  }
}

// ====== FORM ======
.login-popup__form {
  padding: 20px;
}

.login-popup__field-row {
  display: flex;
  gap: 8px;
  margin-bottom: 4px;
}

.login-popup__field {
  margin-bottom: 4px;
}

.login-popup__area-code {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 10px;
  height: 46px;
  background: @input-bg;
  border: 1.5px solid @border;
  border-radius: 10px;
  cursor: pointer;
  flex-shrink: 0;
  position: relative;

  &-text {
    color: #ffffff;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
  }
}

// ====== DROPDOWN ======
.login-popup__dropdown {
  position: absolute;
  top: 52px;
  left: 0;
  right: 0;
  z-index: 100;
  background: #2a2f3e;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);

  &-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    cursor: pointer;
    font-size: 13px;
    color: #ffffff;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);

    &:last-child {
      border-bottom: none;
    }

    &:active {
      background: rgba(36, 238, 137, 0.1);
    }
  }

  &-code {
    margin-left: auto;
    color: @neon;
    font-weight: 600;
    font-size: 12px;
  }
}

.login-popup__input {
  height: 46px;
  background: @input-bg !important;
  border: 1.5px solid @border !important;
  border-radius: 10px !important;
  color: #ffffff;
  font-size: 14px;
  transition: border-color 0.2s;

  &--focus {
    border-color: @neon !important;
  }

  &--error {
    border-color: #ef4444 !important;
  }

  ::v-deep .van-field__label {
    color: #ffffff;
    width: auto;
    margin-right: 8px;
  }

  ::v-deep .van-field__control {
    color: #ffffff;
  }

  ::v-deep .van-field__control::placeholder {
    color: #6b7280;
  }
}

.login-popup__captcha-send {
  color: @neon;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;

  &--disabled {
    color: #6b7280;
    cursor: not-allowed;
  }
}

.login-popup__error {
  color: #ef4444;
  font-size: 11px;
  padding: 4px 4px 8px;
  display: flex;
  align-items: center;
  gap: 4px;
}

// ====== SUBMIT ======
.login-popup__submit {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 24px;
  background: linear-gradient(135deg, @neon 0%, #17b366 100%);
  color: @bg;
  font-size: 16px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  margin-top: 12px;
  box-shadow: 0 4px 16px rgba(36, 238, 137, 0.3);
  transition: transform 0.1s, opacity 0.2s;

  &:active {
    transform: scale(0.97);
  }

  &--disabled {
    background: #3a3f4e;
    color: #6b7280;
    box-shadow: none;
    cursor: not-allowed;
  }
}

// ====== AGREE ======
.login-popup__agree {
  margin-top: 16px;

  &-text {
    font-size: 11px;
    color: @muted;
    line-height: 1.4;
  }

  ::v-deep .van-checkbox__icon .van-icon {
    border-radius: 3px;
    border-color: @neon;
  }

  ::v-deep .van-checkbox__label {
    margin-left: 6px;
    line-height: 1.4;
  }
}

// ====== DIVIDER ======
.login-popup__divider {
  display: flex;
  align-items: center;
  margin: 20px 0 16px;

  &-line {
    flex: 1;
    height: 1px;
    background: @border;
  }

  &-text {
    color: #6b7280;
    font-size: 11px;
    padding: 0 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
}

// ====== GOOGLE ======
.login-popup__google {
  width: 100%;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #ffffff;
  border: none;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  cursor: pointer;
  transition: opacity 0.2s;

  &:active {
    opacity: 0.85;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

// ====== GOOGLE REG POPUP ======
.google-reg-popup {
  width: 93%;
  max-width: 420px;
  background: @bg !important;
  border-radius: 16px !important;
  padding: 24px 20px;
}

.google-reg {
  &__title {
    color: @neon;
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 20px;
  }
}

// ====== OVERRIDES ======
::v-deep .van-popup__close-icon {
  color: #ffffff;
  font-size: 20px;
}

.toastIndex {
  z-index: 99999;
}

@media (min-width: 769px) {
  .login-popup {
    width: 400px !important;
  }
  .google-reg-popup {
    width: 400px !important;
  }
}
</style>
